// src/contexts/SocketContext.js
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      try {
        const res = await axios.get('/api/login/auth/check', { withCredentials: true });
        const role = res.data?.user?.user_role;

        if (cancelled) return;

        if (role === 'admin' || role === 'manager' || role === 'supervisor') {
          const backendURL = process.env.REACT_APP_BASE_URL || 'https://portal.holidayhomecleaning.ae';
          const socket = io(backendURL, {
            withCredentials: true,
            transports: ['websocket'],
          });

          socketRef.current = socket;

          socket.on('connect', () => {
            setIsReady(true);
          });

          socket.on('connect_error', (err) => {
            console.error('[Socket] connect error:', err.message);
            setIsReady(true);
          });

          socket.on('disconnect', () => {
            console.log('[Socket] disconnected');
          });
        } else {
          // Not an admin/manager — skip connecting socket
          setIsReady(true);
        }
      } catch (err) {
        console.warn('[Socket] Failed to check auth:', err.message);
        setIsReady(true);
      }
    };

    init();

    return () => {
      cancelled = true;
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={socketRef.current}>
      {isReady ? children : null}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);